import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { encode } from 'base-64';
import flixfrenzy from '../assets/flixfrenzy.webp';
import './Styles.css';

import { getUser } from '../redux/user';

const SignUp = () => {
  const dispatch = useDispatch();

  const allUsers = useSelector((state) => state.user);

  const navigate = useNavigate();

  const [emailColor, setEmailColor] = useState({});
  const [passColor, setpassColor] = useState({});
  const [emailError, setEmailError] = useState('');
  const [passError, setPassError] = useState('');
  const [registered, setRegistered] = useState(false);

  const handleSignUp = (e) => {
    e.preventDefault();

    const email = e.target[0].value;
    const password = encode(e.target[1].value);

    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
      setEmailError('Please enter a valid email or phone number.');
      setEmailColor({ borderBottom: '1px solid #b92d2b' });
    } else if (e.target[1].value.length < 4) {
      setPassError('Your password must contain above 4 characters.');
      setpassColor({ borderBottom: '1px solid #b92d2b' });
    } else {
      const user = { email, password, login: false };
      dispatch(getUser(user, { type: 'GET_USER' }));
      setRegistered(true);
    }
  };

  if (allUsers.login === true) {
    navigate('/');
  }

  return (
    <div className="credentials-page">
      <div className="credentials-page-header">
        <img className="header-logo" src={flixfrenzy} alt="flixfrenzy logo" />
      </div>
      <div className="credentials-container">
        <h2 className="credentials-header">Sign Up</h2>
        <div className="credentials-form-section">
          <form className="credentials-form" onSubmit={handleSignUp}>
            <div className="single-input">
              <input type="text" className="input" name="email" style={emailColor} required />
              <span> Email or phone number </span>
              <p className="error">{emailError}</p>
            </div>
            <div className="single-input">
              <input type="password" className="input" name="password" style={passColor} required />
              <span> Password </span>
              <p className="error">{passError}</p>
            </div>
            <div className="single-input">
              <button type="submit" className="submit-btn">Sign Up</button>
            </div>
            {/* <div className="remember-help">
            <div className="remember-check">
              <input type="checkbox" className="remember-check" />
              <p className="remember-text">Remember me</p>
            </div>
            <div className="need-help-section">
              <Link to="/" className="need-help">Need help?</Link>
            </div>
          </div> */}
            {registered ? (
              <div className="register-confirm">
                <p className="regist-text">Successfully registered</p>
                <Link to="/login" className="regist-login">Login now</Link>
              </div>
            ) : ''}
          </form>
        </div>
        <div className="other-links-section">
          <p className="new-to-flixfrenzy">Already have a FlixFrenzy account?</p>
          <Link to="/login" className="sign-up-link">Login now</Link>
        </div>
        <div className="notice">
          {/* <p>
            NB
          </p> */}
        </div>
      </div>
    </div>
  );
};

export default SignUp;
